import React, { Component } from 'react';
import SideNavbar from '../components/navbars/SideNavbar';
import NavbarOne from '../components/navbars/NavbarOne';
import { Row, Col, Container } from "react-bootstrap";

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import * as Cookies from "es-cookie";
import Footer from "../components/footer/Footer";
import StudentAdmissionHome from '../components/studentAdmission/student_admissionHome';
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";


const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
    }
  }
`;

const ORGANISATION_PROFILE = gql` 
query($institution_id: Int!) {
    getOrganisationProfile(institution_id: $institution_id){
        id
        organisation_name
        logo
    }
}
`;

const FETCH_STATE = gql` 
query($id: Int) {
    getState(id: $id){
        state_id
        state_name
    }
}
`;

const FETCH_INDIVIDUAL_ADMISSION_DETAILS = gql` 
query($student_id: Int) {
    getIndividualAdmissionDetails(student_id: $student_id){
        form1 {
            student_first_name
            student_last_name
            student_mobile
            date_of_birth
            gender
            student_photo
            father_name
            father_photo
            father_occupation
            father_contact_no
            mother_name
            mother_photo
            mother_contact_no
            mother_occupation
            residential_status
            religion
            nationality
            other_identity
            email
            address
            city
            pincode
            state_id
            guardian1_name
            guardian1_photo
            guardian1_number
            guardian2_name
            guardian2_photo
            guardian2_number
            institute_id
            branch_id
            exam_id
            source
          }
          previousAcademices {
            board_name
            board_exam_id
            academic_year
            gpa_percentage
            college_name
          }
          form2 {
            admission_form_field_id
            value
          }
    }
}
`;

class StudentAdmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: 0,
            student_id: 0,
            status: ""
        }
    }

    componentDidMount() {
        if (this.props.history.location.state != undefined) {
            let history = this.props.history.location.state
            this.setState({
                branch_id: parseInt(history.branch_id),
                student_id: history.student_id,
                status: history.name

            })
        }
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {


        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getOrganisationProfile = this.props.getOrganisationProfile;
        const loading2 = getOrganisationProfile.loading;
        const error2 = getOrganisationProfile.error;

        const getStates = this.props.getStates;
        const loading3 = getStates.loading;
        const error3 = getStates.error;

        const getIndividualAdmissionDetails = this.props.getIndividualAdmissionDetails
        const loading4 = getIndividualAdmissionDetails.loading;
        const error4 = getIndividualAdmissionDetails.error;


        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error3 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error4 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        console.log("getIndividualAdmissionDetails", getIndividualAdmissionDetails);

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />

                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0" style={{ minHeight: "50vh" }}>
                        <Container fluid>
                            {
                                loading1 == true || loading2 == true || loading3 == true || loading4 == true ?
                                    (
                                        <Container>
                                            <Row>
                                                <Col sm={12}>
                                                    <div className="d-flex align-items-center spinner-border text-primary text-center loading-img-center"></div>
                                                </Col >
                                            </Row>
                                        </Container >
                                    )
                                    :
                                    (
                                        <>
                                            {
                                                (() => {
                                                    let globalsData = globals.globals;

                                                    if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                                                        let globalBranches = [];

                                                        globalsData.globalBranches.map((item) => {
                                                            if (Cookies.get("branch_id") == item.id) {
                                                                globalBranches.push(item)
                                                            }
                                                        });

                                                        globalsData.globalBranches = globalBranches

                                                    }
                                                    console.log("globalsData", globalsData);

                                                    return (
                                                        <>

                                                            <StudentAdmissionHome
                                                                globals={globalsData}
                                                                states={getStates.getState}
                                                                stateData={this.state}
                                                                getOrganisationProfile={getOrganisationProfile.getOrganisationProfile}
                                                                getIndividualAdmissionDetails={getIndividualAdmissionDetails.getIndividualAdmissionDetails}
                                                            />
                                                        </>
                                                    );
                                                })()
                                            }
                                        </>

                                    )
                            }
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        )
    }
}


export default withRouter(compose(
    graphql(FETCH_GLOBALS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
    graphql(ORGANISATION_PROFILE,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                }
                ,
                fetchPolicy: 'cache-and-network'
            }), name: "getOrganisationProfile"
        }),
    graphql(FETCH_STATE,
        {
            options: props => ({
                variables: {
                    id: parseInt(0)
                }
                ,
                fetchPolicy: 'cache-and-network'
            }), name: "getStates"
        }),
    graphql(FETCH_INDIVIDUAL_ADMISSION_DETAILS,
        {
            options: props => ({
                variables: {
                    student_id: parseInt(props.history.location.state != undefined ? props.history.location.state.student_id : 0)
                }
                ,
                fetchPolicy: 'cache-and-network'
            }), name: "getIndividualAdmissionDetails"
        }),
)(StudentAdmission));
